import { render, staticRenderFns } from "./ShoppingCartItem.vue?vue&type=template&id=339d631a&scoped=true&"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartItem.vue?vue&type=style&index=0&id=339d631a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339d631a",
  null
  
)

export default component.exports